export default __webpack_public_path__ + "static/mid4b-599ea5746e88f255dd07bf549084a488.png";